// [ai] The catalog's props contract: every registered widget declares a schema (catalog.ts); the frame checks the view.json
// props against it before rendering, so a wrong prop is one line in an error card instead of a crash deep in a component.
export type PropType = "string" | "number" | "boolean" | "list" | "object";
export type PropSpec = { type: PropType; required?: boolean; enum?: readonly string[] };
export type Schema = Record<string, PropSpec>;
const ARTICLE: Record<PropType, string> = { string: "a string", number: "a number", boolean: "true or false", list: "a list", object: "an object" };
const is = (t: PropType, v: unknown) => t === "list" ? Array.isArray(v) : t === "object" ? !!v && typeof v === "object" && !Array.isArray(v) : typeof v === t;

/** The first fault as one sentence, or null when the props fit. */
export function checkProps(schema: Schema, props: Record<string, unknown> | undefined): string | null {
  if (props === undefined) props = {};
  if (!props || typeof props !== "object" || Array.isArray(props)) return "props must be an object";
  for (const [k, s] of Object.entries(schema)) {
    const v = props[k];
    if (v === undefined) { if (s.required) return `props.${k} is required (${ARTICLE[s.type]})`; continue; }
    if (!is(s.type, v)) return `props.${k} must be ${ARTICLE[s.type]}`;
    if (s.enum && !s.enum.includes(v as string)) return `props.${k} must be one of ${s.enum.join(", ")}`;
  }
  return null;
}
